/// <amd-module name="Repos/Tfvc/Views/ShelvesetsHub/ShelvesetsListDataProviderService" />
import { ChangeList, TfvcItem } from "Repos/Common/Contracts/Git";
import { IIdentity } from "VSS/Features/Identities/IdentityService";
import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";
import { IdentityRef } from "VSS/Platform/Contracts/WebApi";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { IAnchorProps } from "VSSUI/Link";

export interface IShelvesetsListDataProviderService extends IVssService {
    fetchShelvesets(owner: IIdentity): Promise<ShelvesetsListResult | undefined>;
    getInitialShelvesets(): ShelvesetsListResult | undefined;
}

export interface IShelveset extends ChangeList<TfvcItem> {
    shelvesetName: string;
    linkProps: IAnchorProps;
    ownerRef: IdentityRef;
}

export interface ShelvesetsListResult {
    hasMore: boolean;
    searchCancelled: boolean;
    shelvesets: IShelveset[];
}

const ShelvesetsListDataProviderKey = "ms.vss-code-web.shelvesets-list-data-provider";

class ShelvesetsListDataProviderService extends VssService implements IShelvesetsListDataProviderService {
    private latestRequestKey: number = 0;

    public async fetchShelvesets(owner: IIdentity): Promise<ShelvesetsListResult | undefined> {
        const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");

        this.latestRequestKey++;
        const requestKey = this.latestRequestKey;

        const data = await contributionService.getDataAsync<ShelvesetsListResult>(
            ShelvesetsListDataProviderKey,
            { user: owner.localId, changeListType: "shelvesets" },
            true
        );

        return data && this.processData(data, requestKey);
    }

    public getInitialShelvesets(): ShelvesetsListResult | undefined {
        const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
        const data = contributionService.getData<ShelvesetsListResult>(ShelvesetsListDataProviderKey);
        return data && data.shelvesets && this.processData(data, this.latestRequestKey);
    }

    private processData(data: ShelvesetsListResult, requestKey: number): ShelvesetsListResult {
        return {
            shelvesets: data.shelvesets || [],
            hasMore: Boolean(data.hasMore),
            searchCancelled: !(this.latestRequestKey === requestKey)
        };
    }
}

export function getShelvesetsListDataProviderService(context: IVssPageContext) {
    return context.getService<IShelvesetsListDataProviderService>("IShelvesetsListDataProviderService");
}

Services.add("IShelvesetsListDataProviderService", { serviceFactory: ShelvesetsListDataProviderService });
